(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1745],{

/***/ 9361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 8193:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/tech-tales",
      function () {
        return __webpack_require__(4464);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _slicedToArray = (__webpack_require__(4941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(7294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
var observers = new Map();
var idList = [];
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 4464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ TechTales; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./styles/Tech.module.css
var Tech_module = __webpack_require__(5370);
var Tech_module_default = /*#__PURE__*/__webpack_require__.n(Tech_module);
;// CONCATENATED MODULE: ./components/blog/BlogCardTechLts.js





var BlogCardTechLts = function(param) {
    var title = param.title, src = param.src, alt = param.alt, date = param.date, time = param.time, slug = param.slug, desc = param.desc;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex justify-between cursor-pointer  ".concat((Tech_module_default()).blog_lts_container),
        onClick: function() {
            return router.push("/blog/".concat(slug, "/"));
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center w-4/5 sm:w-2/5 relative ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Tech_module_default()).blog_lts_img,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: src,
                            alt: alt,
                            width: "150",
                            height: "200",
                            layout: "fill",
                            sizes: "(max-width: 500px) 50vw, (max-width: 1200px) 70vw, 100vw"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Tech_module_default()).blog_lts_img_bg
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col  ".concat((Tech_module_default()).blog_lts_content),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between ".concat((Tech_module_default()).blog_date),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: date
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: time
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Tech_module_default()).blog_desc,
                        children: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: function() {
                            return router.push("/blog/".concat(slug, "/"));
                        },
                        className: "flex justify-between ml-2 cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "mr-2 ",
                                        height: "20",
                                        width: "20",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                            cx: "10",
                                            cy: "10",
                                            r: "7",
                                            stroke: "black",
                                            strokeWidth: "0.5",
                                            fill: "#C30B0B"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Read Now"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    strokeWidth: "4",
                                    stroke: "currentColor",
                                    className: "w-4 h-4 ml-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        d: "M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog_BlogCardTechLts = (BlogCardTechLts);

;// CONCATENATED MODULE: ./components/blog/BlogCardTechFeatured.js




var BlogCardTechFeatured = function(param) {
    var title = param.title, img = param.img, date = param.date, desc = param.desc, alt = param.alt, slug = param.slug;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center justify-center  mt-10 mr-20 relative cursor-pointer ".concat((Tech_module_default()).blog_featured),
        onClick: function() {
            return router.push("/blog/".concat(slug, "/"));
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Tech_module_default()).blog_featured_img,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: img,
                    alt: alt,
                    width: "150",
                    height: "600",
                    sizes: "(max-width: 500px) 50vw, (max-width: 1200px) 70vw, 100vw"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Tech_module_default()).blog_featured_top,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center ".concat((Tech_module_default()).blog_featured_title),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            className: "mr-2 w-[28px]",
                            height: "20",
                            width: "20",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                cx: "10",
                                cy: "10",
                                r: "7",
                                stroke: "black",
                                strokeWidth: "0.5",
                                fill: "#C30B0B"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                            children: title
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Tech_module_default()).blog_featured_img_grd,
                onClick: function() {
                    return router.push("/blog/".concat(slug, "/"));
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: desc
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-sm mb-2",
                                children: date
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                strokeWidth: "4",
                                stroke: "currentColor",
                                className: "w-4 h-4 ml-3 cursor-pointer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    d: "M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var blog_BlogCardTechFeatured = (BlogCardTechFeatured);

;// CONCATENATED MODULE: ./pages/blog/tech-tales.js






var Navbar = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(1853)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1608), __webpack_require__.e(3193)]).then(__webpack_require__.bind(__webpack_require__, 3193));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3193)
            ];
        }
    }
});
TechTales.title = "Tech Tales";
TechTales.desc = "Itmtb's technology blogs";
TechTales.header_img = "https://www.itmtb.com/blog/grid/techTalesBg.webp";
TechTales.pathname = "https://www.itmtb.com" + "tech-tales";
TechTales.keywords = "tech, technology, design, coding, programming, react, next js, itmtb, technologies.";
var __N_SSG = true;
function TechTales(param) {
    var sortedData = param.sortedData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: " blog min-h-screen bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative z-10 ".concat((Tech_module_default()).tech_hero_container),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative z-10 ".concat((Tech_module_default()).tech_hero),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/blog/grid/techTalesBg.webp",
                                alt: "tech-tales",
                                width: "1200",
                                height: "660",
                                layout: "fill",
                                priority: true,
                                sizes: "(max-width: 500px) 50vw, (max-width: 1200px) 70vw, 100vw"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "absolute z-20 ".concat((Tech_module_default()).tech_hero_text),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: "TECH TALES"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        children: "Dive Into The Infinite Realm Of Technology"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Tech_module_default()).tech_latest,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "Latest Blogs -"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Tech_module_default()).tech_latest_blogs,
                                children: sortedData.slice(0, 2).map(function(post) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogCardTechLts, {
                                        title: post.title,
                                        src: post.img,
                                        alt: post.slug,
                                        date: post.date,
                                        time: post.time,
                                        slug: post.slug,
                                        desc: post.subtitle
                                    }, post.slug);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Tech_module_default()).tech_featured,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        children: "Featured Blogs -"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-wrap",
                        children: sortedData.slice(2).map(function(post) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogCardTechFeatured, {
                                title: post.title,
                                img: post.img,
                                alt: post.slug,
                                slug: post.slug,
                                date: post.date,
                                desc: post.subtitle
                            }, post.slug);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
}; // export default TechTales;


/***/ }),

/***/ 5370:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tech_hero_container":"Tech_tech_hero_container__H42N7","tech_hero_text":"Tech_tech_hero_text__dvH_4","tech_hero":"Tech_tech_hero__QTX0E","tech_latest":"Tech_tech_latest__IPXnR","tech_latest_blogs":"Tech_tech_latest_blogs__nVxk1","blog_lts_container":"Tech_blog_lts_container__BEc_8","blog_lts_img":"Tech_blog_lts_img__iBS3N","blog_lts_img_bg":"Tech_blog_lts_img_bg__TfYhA","blog_lts_content":"Tech_blog_lts_content__2Xv8Q","blog_date":"Tech_blog_date__UoEm_","blog_desc":"Tech_blog_desc__pVkbQ","tech_featured":"Tech_tech_featured__Q3byo","blog_featured_img":"Tech_blog_featured_img__TE7_s","blog_featured_img_grd":"Tech_blog_featured_img_grd__SE8GW","blog_featured_top":"Tech_blog_featured_top__cIR3T","blog_featured_title":"Tech_blog_featured_title___pszb","blog_featured":"Tech_blog_featured__yCslC"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(8193); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);